// import React from 'react';
// import './Typeofmember.css';
// import membership from '../images/Membership.jpg';
// import Startanewclub from '../images/Membership/Startanewclub.jpg'
// import { Link } from 'react-router-dom';
// import startaleo from '../images/Membership/Startaclub.jpg'
// import m1 from '../images/Membership/1.png';
// import typofclub from '../images/Membership/MembershipAwards1.jpg'
// import campusclub from '../images/Membership/campusclub.png'
// import virtualclub from '../images/Membership/virtualclub.jpg'
// import specialtyclb from '../images/Membership/specialtyclubs.png'
// import traditionalclub from '../images/Membership/traditionalclubs.png'


// import membershipdevgrant from '../images/Membership/membershipdevgrant.jpg'
// import lionjourney from '../images/Membership/lionjourney.jpg'
// import NewMemberInductionCeremonies from '../images/Membership/LeoAwards.jpg'

// const LeoAwards = () => {
//     return (
//         <>
//             <div className="membership-container">
//                 {/* Sidebar */}
//                 <div className="sidebar">
//                     <h3 className="sidebar-title">Categories</h3>
//                     <ul className="category-list scrollable-list">
//                         <Link to='/typesofmembers'> <li >
//                             <img src={membership} alt="Membership" />
//                             Types of Members
//                         </li></Link>
//                         <Link to='/Startanewclub'>   <li >
//                             <img src={Startanewclub} alt="Most Viewed" />
//                             Start a new club
//                         </li></Link>
//                         <Link to='/StartaLeoclub'>  <li >
//                             <img src={startaleo} alt="Membership" />
//                             Start a Leo Club
//                         </li> </Link>
//                       <Link to='/TypesofClub'>   <li >
//                             <img src={membership} alt="Membership" />
//                             Types of Clubs

//                         </li ></Link>
//                         <Link to='/membershipgrant'>     <li >
//                             <img src={membership} alt="Membership" />
//                             Membership Grants
//                         </li>  </Link>
//                            <Link to='/newMembershipform'> <li>
//                             <img src={membership} alt="Membership" />
//                             New Member Form
//                         </li></Link>
//                         <Link to='/memberInductionCeremony'>  <li  >
//                             <img src={membership} alt="Membership" />
//                             Member Induction Ceremony
//                         </li></Link>
//                             <Link to='/memberOrientation'>     <li>
//                             <img src={membership} alt="Membership" />
//                             New Member Orientation
//                         </li></Link>
//                          <Link to='/myLciLogintocheckdues'>    <li >
//                             <img src={membership} alt="Membership" />
//                             My LCI Login to Check dues
//                         </li></Link>
//                              <Link to='/payMembershipDues'>     <li  >
//                             <img src={membership} alt="Membership" />
//                             Pay Membership Dues
//                         </li></Link>
//                          <Link to='/'>      <li >
//                             <img src={membership} alt="Membership" />
//                             Membership Awards
//                         </li></Link>
//                             <li style={{ fontWeight: 'bold', color: '#005399' }}>
//                             <img src={membership} alt="Membership" />
//                             Leo Awards
//                         </li>
//                     </ul>
//                 </div>

//                 {/* Right Content Area with Cards */}
//                 <div className="membership-content">
//                     {/* Card 1 */}     
//                     <div className="membership-card">
//                         <div className="card-image">
//                             <img src={NewMemberInductionCeremonies} alt="Leo-Lion Membership" />
//                         </div>
//                         <div className="card-content">
//                             <h2 >Leo Awards</h2>
//                             <p>


// Leos of the Year Award – A multiple district council of governors or single district (that is not part of a multiple district) may nominate one high achieving Leo each year for this medallion and certificate award. Applications must be submitted by March 1. Congratulations to all the current award recipients!

// Leo Club President Achievement Award – A Leo club president who meets specific requirements during his/her year in office may be awarded this certificate by the Leo club advisor with the approval of the sponsoring Lions club president. Award criteria categories include leadership development, membership extension, administration and Leo club activities.</p>

//                         </div>
//                     </div>

//                     {/* Card 2 */}
//                     {/* <div className="membership-card">
//                         <div className="card-content">
//                             <h2>Membership Awards</h2>
//                             <p>
//                                Membership Awards 

// A strong membership is vital to the success of your club, district and the Lions Clubs International organization worldwide. Without dedicated members, there would be no one to serve those in need. Lions International offers opportunities for all members to receive recognition for the role they play in growing our organization around the world.

// Awards for Individuals


// The following awards are opportunities for all Lions to earn, regardless of title:

// Milestone Chevron Award Program
// This program recognizes Lions for their long-term service, beginning at 10 years, and continuing in 5-year increments. There are two different types of chevrons, varying slightly in appearance. The Charter Monarch Chevron, available to founding club members only, and the Monarch Chevron. Learn more >

// Membership Key Awards Program
// This progressive awards program recognizes Lions who sponsor new members that remain active for at least a year. It begins with only two members sponsored, and is something that all Lions can do beginning on their first day of membership. Learn more >

// Extension Awards
// The extension awards are presented to two Lions, who, in the opinion of the serving district governor, provided the greatest assistance in the organization of a new Lions club that remains active and in good standing for at least a year. This is a progressive awards program beginning at just one club, Lions can earn personalized pins for clubs 1-5, 10, 15, 20, 25, 30, 40, 50, 75, 100 and 150 clubs.

// Campus Award Pin
// This pin can be presented to up to two Lions who help charter a Campus Lions club, as determined by the district governor.

// Club Branch Pin
// This prestigious pin is awarded to the first branch liaison when a club branch is formed.

// Specialty Clubs Program Coordinator Awards
// SCP coordinators who achieve their approved specialty club development plan will receive an E-certificate of appreciation

// SCP coordinators who organize 5-9 new specialty clubs will receive a distinctive pin

// SCP coordinators who organize 10 or more new specialty clubs will receive a distinctive medal

// Awards for Clubs


// The following awards represent some of the ways your club can be recognized for outstanding work in membership development:

// New Club Sponsor Club Banner Patch
// Clubs that sponsor a new club receive a banner patch that can proudly be displayed on the club banner.

// Campus Banner Patch
// Clubs that sponsor a campus club receives a distinctive patch that can be displayed on the club banner. 

// Club Branch Patch
// Clubs that serve as a parent to a club branch receive a patch to be displayed on their banner for recognition of their efforts to develop membership.

// Membership Satisfaction Award
// Clubs can earn this prestigious patch that can be displayed on their banner so that all who see it, know that there are happy members. The patch is earned by either retaining 90% of your members for a fiscal year, or by reversing membership losses. Earn additional “tabs” for each subsequent year to affix to your banner for increased recognition. Learn more >

// Awards for Districts


// The following awards are earned at the district level by meeting membership development goals:

// District Governor Extension Award
// This special pin is awarded to the immediate past district governor who chartered at least one club in during their year as governor, provided the club remains in good standing for at least a year. The pin is personalized to display the number of clubs chartered during their year.
//     </p>
//                         </div>
//                         <div className="card-image">
//                             <img src={typofclub} alt="Regular Membership" />
//                         </div>
//                     </div> */}

//                     {/* Card 3 */}
//                     {/* <div className="membership-card">
//                         <div className="card-image">
//                             <img src={campusclub} alt="Student Membership" />
//                         </div>
//                         <div className="card-content">
//                             <h2>Campus Clubs</h2>
//                             <p>
//                                 Campus clubs offer students the opportunity to build leadership skills, and create a common bond of service with fellow students. Members of campus clubs may also be eligible for student membership—see "Membership Types" for more details. Learn more about campus clubsKnow More...       </p>
//                         </div>
//                     </div> */}

//                     {/* Card 4 */}
//                     {/* <div className="membership-card">
//                         <div className="card-content">
//                             <h2>Virtual Clubs</h2>
//                             <p>Virtual clubs conduct some or all club meetings remotely, over the phone or via the internet. This club type allows a more widely-distributed group of club members to plan and execute service projects with ease, and is a great fit for those with busy schedules. Learn more about virtual clubs Kn...   </p>
//                         </div>
//                         <div className="card-image">
//                             <img src={virtualclub} alt="Honorary Membership" />
//                         </div>
//                     </div> */}

//                     {/* Additional Card */}
//                     {/* <div className="membership-card">
//                         <div className="card-image">
//                             <img src={specialtyclb} alt="Life Membership" />
//                         </div>
//                         <div className="card-content">
//                             <h2>Specialty Clubs</h2>
//                             <p>

// Specialty clubs are much like traditional clubs, but bring together a group of individuals who share a common interest in addition to a commitment to service. A specialty may share a hobby, like snowboarding or knitting, or a common cultural background. Learn more about specialty clubsKnow more...     </p>
//                         </div>

//                     </div> */}


//          {/* <div className="membership-card">

//                         <div className="card-content">
//                             <h2>Traditional Clubs</h2>
//                             <p>

// Most Lions clubs are formed on the traditional club model.These clubs bring together a group of service-minded individuals who want to better their community, and meet locally on a regular basis. Learn more about traditional clubs Know More...
//                 </p>    </div>
//                   <div className="card-image">
//                             <img src={traditionalclub} alt="Life Membership" />
//                         </div>

//                     </div> */}
//                 </div>
//             </div>
//         </>
//     );
// };

// export default LeoAwards;

// src/pages/ContentPage.js

// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import './Typeofmember.css';
// import membership from '../images/Membership.jpg';
// import { useLocation } from 'react-router-dom';

// const ContentPage = () => {
//   const { id } = useParams(); // Universal ID for any level
//   //   const [data, setData] = useState(null);
//   const { search } = useLocation();
//   const params = new URLSearchParams(search);
//   const [subMenus, setSubMenus] = useState([]);
//     const [menus, setMenus] = useState([]);
    
//       const [subPlusMenus, setSubPlusMenus] = useState([]);

//   const menus_id = params.get("menus_id");
//   const sub_menus_id = params.get("sub_menus_id");
//   const sub_plus_menus_id = params.get("sub_plus_menus_id");

//   const [data, setData] = useState([]);

//   const fetchMenus = async () => {
//     const subs = await fetch("https://lcoiapi.emedha.in/appi/menus_all").then(r => r.json());
//     setMenus(subs);
//   };
//   const fetchSubMenus = async () => {
//     const subs = await fetch("https://lcoiapi.emedha.in/appi/sub_menus").then(r => r.json());
//     setSubMenus(subs);
//   };
//     const fetchSubPlusMenus = async () => {
//     const subs = await fetch("https://lcoiapi.emedha.in/appi/sub_plus_menus").then(r => r.json());
//     setSubPlusMenus(subs);
//   };

//   useEffect(() => {
// fetchMenus();
//     fetchSubMenus();
// fetchSubPlusMenus();
//   }, []);

//   // useEffect(() => {
//   //   const query = new URLSearchParams({ menus_id });

//   //   if (sub_menus_id) query.append("sub_menus_id", sub_menus_id);
//   //   if (sub_plus_menus_id) query.append("sub_plus_menus_id", sub_plus_menus_id);

//   //   fetch(`https://lcoiapi.emedha.in/appi/menus_data?${query.toString()}`)
//   //     .then(res => res.json())
//   //     .then(setData)
//   //     .catch(console.error);
//   // }, [menus_id, sub_menus_id, sub_plus_menus_id]);


//   useEffect(() => {
//   const query = new URLSearchParams({ menus_id });

//   if (sub_menus_id) query.append("sub_menus_id", sub_menus_id);
//   if (sub_plus_menus_id) query.append("sub_plus_menus_id", sub_plus_menus_id);

//   fetch(`https://lcoiapi.emedha.in/appi/menus_data?${query.toString()}`)
//     .then(res => res.json())
//     .then(json => {
//       if (Array.isArray(json)) {
//         setData(json);
//       } else {
//         alert("Error: Expected an array of data but got invalid format.");
//         console.error("Invalid data format:", json);
//         setData([]); // Set empty array to avoid map crash
//       }
//     })
//     .catch(err => {
//       alert("Failed to fetch data from server.");
//       console.error(err);
//     });
// }, [menus_id, sub_menus_id, sub_plus_menus_id]);



//   // if (!data) return <p>Loading...</p>;
//   // if (!data || data.length === 0) return <p>Loading...</p>;

// if (!data ||data.length === 0) {
//   return <p style={{ color: "red", padding: "20px" }}>⚠️ No content available for this section.</p>;
// }

  
//   console.log('this is data ', data)

//   console.log('menus_id', menus_id)
//   console.log('sub_menus_id', sub_menus_id)
//   console.log('sub_plus_menus_id', sub_plus_menus_id)
//   console.log('this is the subMenus', subMenus)
//   //   useEffect(() => {
//   //     fetch(`https://lcoiapi.emedha.in/appi/menus_data/${id}`)
//   //       .then(res => res.json())
//   //       .then(setData)
//   //       .catch(console.error);
//   //   }, [id]);

//   //   if (!data) return <p>Loading...</p>;

  
//   const getMenuName = (menus_id) => {
//     const found = menus.find((m) => m.id === Number(menus_id));
//     return found ? found.menu : "No Menu";
//   };

//   const getSubMenuName = (sub_menus_id) => {
//     const found = subMenus.find((s) => s.id === Number(sub_menus_id));
//     return found ? found.sub_menu : "";
//   };
//   const getSubPlusMenuName = (sub_plus_menus_id) => {
//     const found = subPlusMenus.find((s) => s.id === Number(sub_plus_menus_id));
//     return found ? found.sub_plus_menus : "";
//   };


//   return (
//     <>
//     {/* <div style={{padding:'15px 15px',justifyContent:'flex-end',alignItems:'end'}}>
//       <p>{getMenuName(menus_id)}  -- {getSubMenuName(sub_menus_id)}  -- {getSubPlusMenuName(sub_plus_menus_id)}</p>  </div>  */}

// <div
//   style={{
//     position: 'absolute',
//     // top: '15px',
//     right: '10px',
//     background: '#005399',
//     padding: '10px 15px',
//     borderRadius: '8px',
//     boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
//     fontSize: '12px',
//     display: 'flex',
//     alignItems: 'center',
//     color: '#ffffff',
//     fontWeight: 500,
 
//     // zIndex: 999
//   }}
// >
//   <span style={{ marginRight: '8px', color: '#ffffff' }}>📁</span>
//   <span>{getMenuName(menus_id)}</span>
//   <span style={{ margin: '0 6px', color: '#ffffff' }}>›</span>
//   <span>{getSubMenuName(sub_menus_id)}</span>
//   <span style={{ margin: '0 6px', color: '#ffffff' }}>›</span>
//   <span>{getSubPlusMenuName(sub_plus_menus_id)}</span>
// </div>


//     <div className="membership-container">
      
//       <div className="sidebar">
//         <h3 className="sidebar-title">Categories</h3>
//         {/* <ul className="category-list scrollable-list">
//           <li style={{ fontWeight: 'bold', color: '#005399' }}>
//             <img src={membership} alt="" />
//             {data.heading || 'Title'}
//           </li>
//         </ul> */}
//         <ul className="category-list scrollable-list">
//           {/* <li style={{ fontWeight: 'bold', color: '#005399' }}>
//             <img src={membership} alt="" />
//             Categories
//           </li> */}
//           {subMenus
//             .filter(menu => menu.menu_id === Number(menus_id)) // Filter subMenus by current menus_id
//             .map(menu => (
//               <li key={menu.id}>{menu.sub_menu}</li>
//             ))
//           }
//         </ul>

//       </div>

//       <div className="membership-content">
//          {/*  <div className="membership-card">
//         {data.image && (
//             <div className="card-image">
//               <img
//                 src={data.image}
//                 alt={data.heading}
//               />
//             </div>
//           )} */}
         

//           {/* <div className="card-content">
//             <h2>{data.heading}</h2>
//             <p>{data.content}</p>
//           </div> 
//         </div>*/}


//         {data.map((item, index) => (
//   <div key={index} className="membership-card">
//     {item.image && (
//       <div className="card-image">
//         <img src={item.image} alt={item.heading} />
//       </div>
//     )}
//     <div className="card-content">
//       <h2>{item.heading}</h2>
//       <p>{item.content}</p>
//     </div>
//   </div>
// ))}

//       </div>
//     </div>
//         </>
//   );
// };

// export default ContentPage;


import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import './Typeofmember.css';
import membership from '../images/Membership.jpg';
import { translateText } from "../Navbar/Navbar"; // ✅ reuse same helper

const ContentPage = ({ selectedLang }) => {
  const { id } = useParams();
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  // original server data
  const [menus, setMenus] = useState([]);
  const [subMenus, setSubMenus] = useState([]);
  const [subPlusMenus, setSubPlusMenus] = useState([]);
  const [data, setData] = useState([]);

  // translated copies (do NOT mutate originals)
  const [tMenus, setTMenus] = useState([]);
  const [tSubMenus, setTSubMenus] = useState([]);
  const [tSubPlusMenus, setTSubPlusMenus] = useState([]);
  const [tData, setTData] = useState([]);

  // UI labels
  const [labels, setLabels] = useState({ categories: "Categories", noContent: "⚠️ No content available for this section." });

  const menus_id = params.get("menus_id");
  const sub_menus_id = params.get("sub_menus_id");
  const sub_plus_menus_id = params.get("sub_plus_menus_id");

  // ✅ resolve lang: prop -> localStorage -> 'en'
  const lang = selectedLang || localStorage.getItem('selectedLang') || 'en';

  // ---- fetches (unchanged) ----
  const fetchMenus = async () => {
    const resp = await fetch("https://lcoiapi.emedha.in/appi/menus_all").then(r => r.json());
    setMenus(resp);
  };
  const fetchSubMenus = async () => {
    const resp = await fetch("https://lcoiapi.emedha.in/appi/sub_menus").then(r => r.json());
    setSubMenus(resp);
  };
  const fetchSubPlusMenus = async () => {
    const resp = await fetch("https://lcoiapi.emedha.in/appi/sub_plus_menus").then(r => r.json());
    setSubPlusMenus(resp);
  };

  useEffect(() => {
    fetchMenus();
    fetchSubMenus();
    fetchSubPlusMenus();
  }, []);

  useEffect(() => {
    const query = new URLSearchParams({ menus_id });
    if (sub_menus_id) query.append("sub_menus_id", sub_menus_id);
    if (sub_plus_menus_id) query.append("sub_plus_menus_id", sub_plus_menus_id);

    fetch(`https://lcoiapi.emedha.in/appi/menus_data?${query.toString()}`)
      .then(res => res.json())
      .then(json => Array.isArray(json) ? setData(json) : setData([]))
      .catch(() => setData([]));
  }, [menus_id, sub_menus_id, sub_plus_menus_id]);

  // ---- translate exactly like HomeScreen: 1 effect, build translated state, set once ----
  useEffect(() => {
    let cancelled = false;

    async function translateAll() {
      // quick pass-through for English
      if (!lang || lang === 'en') {
        if (cancelled) return;
        setTMenus(menus);
        setTSubMenus(subMenus);
        setTSubPlusMenus(subPlusMenus);
        setTData(data);
        setLabels({ categories: "Categories", noContent: "⚠️ No content available for this section." });
        return;
      }

      // helper to translate specific fields in an array of objects
      const translateFields = async (arr, fields) => {
        return Promise.all(
          (arr || []).map(async (obj) => {
            const out = { ...obj };
            for (const f of fields) {
              if (out[f]) out[f] = await translateText(String(out[f]), lang);
            }
            return out;
          })
        );
      };

      const [
        menusTX,
        subMenusTX,
        subPlusMenusTX,
        dataTX,
        categoriesLabel,
        noContentLabel,
      ] = await Promise.all([
        translateFields(menus, ['menu']),
        translateFields(subMenus, ['sub_menu']),
        translateFields(subPlusMenus, ['sub_plus_menus']),
        translateFields(data, ['heading', 'content']),
        translateText("Categories", lang),
        translateText("⚠️ No content available for this section.", lang),
      ]);

      if (cancelled) return;
      setTMenus(menusTX);
      setTSubMenus(subMenusTX);
      setTSubPlusMenus(subPlusMenusTX);
      setTData(dataTX);
      setLabels({ categories: categoriesLabel, noContent: noContentLabel });
    }

    translateAll();
    return () => { cancelled = true; };
  }, [lang, menus, subMenus, subPlusMenus, data]);

  // ---- derived getters (use translated arrays) ----
  const getMenuName = (menus_id) => {
    const found = (tMenus || []).find((m) => m.id === Number(menus_id));
    return found ? (found.menu || "No Menu") : "No Menu";
    // if you want Menu itself translated too, translateFields above already did it
  };
  const getSubMenuName = (sub_menus_id) => {
    const found = (tSubMenus || []).find((s) => s.id === Number(sub_menus_id));
    return found ? (found.sub_menu || "") : "";
  };
  const getSubPlusMenuName = (sub_plus_menus_id) => {
    const found = (tSubPlusMenus || []).find((s) => s.id === Number(sub_plus_menus_id));
    return found ? (found.sub_plus_menus || "") : "";
  };

  if (!tData || tData.length === 0) {
    return <p style={{ color: "red", padding: "20px" }}>{labels.noContent}</p>;
  }

  return (
    <>
      <div
        style={{
          position: 'absolute',
          right: '10px',
          background: '#005399',
          padding: '10px 15px',
          borderRadius: '8px',
          boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
          fontSize: '12px',
          display: 'flex',
          alignItems: 'center',
          color: '#ffffff',
          fontWeight: 500,
        }}
      >
        <span style={{ marginRight: '8px', color: '#ffffff' }}>📁</span>
        <span>{getMenuName(menus_id)}</span>
        <span style={{ margin: '0 6px', color: '#ffffff' }}>›</span>
        <span>{getSubMenuName(sub_menus_id)}</span>
        <span style={{ margin: '0 6px', color: '#ffffff' }}>›</span>
        <span>{getSubPlusMenuName(sub_plus_menus_id)}</span>
      </div>

      <div className="membership-container">
        <div className="sidebar">
          <h3 className="sidebar-title">{labels.categories}</h3>
          <ul className="category-list scrollable-list">
            {(tSubMenus || [])
              .filter(menu => menu.menu_id === Number(menus_id))
              .map(menu => (
                <li key={menu.id}>{menu.sub_menu}</li>
              ))
            }
          </ul>
        </div>

        <div className="membership-content">
          {(tData || []).map((item, index) => (
            <div key={index} className="membership-card">
              {item.image && (
                <div className="card-image">
                  <img src={item.image} alt={item.heading} />
                </div>
              )}
              <div className="card-content">
                <h2>{item.heading}</h2>
                <p>{item.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ContentPage;
